module.exports = __webpack_public_path__ + "static/UI pattern - navigation 3-1195e7742881f2904d88783c0a14381f.png";